import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SortSwitch = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.513 3.427a1.75 1.75 0 0 1 2.474 0L21.28 6.72a.75.75 0 0 1-1.06 1.06L17.5 5.06v15.19a.75.75 0 1 1-1.5 0V5.06l-2.72 2.72a.75.75 0 1 1-1.06-1.06zM7.25 3a.75.75 0 0 1 .75.75v15.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.293 3.293a1.75 1.75 0 0 1-2.474 0L2.72 17.28a.75.75 0 0 1 1.06-1.06l2.72 2.72V3.75A.75.75 0 0 1 7.25 3'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.513 3.427a1.75 1.75 0 0 1 2.474 0L21.28 6.72a.75.75 0 0 1-1.06 1.06L17.5 5.06v15.19a.75.75 0 1 1-1.5 0V5.06l-2.72 2.72a.75.75 0 1 1-1.06-1.06zM7.25 3a.75.75 0 0 1 .75.75v15.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.293 3.293a1.75 1.75 0 0 1-2.474 0L2.72 17.28a.75.75 0 0 1 1.06-1.06l2.72 2.72V3.75A.75.75 0 0 1 7.25 3'
        fill='currentColor'
      />
    )}
  </IconBase>
);
